import React, { FC } from 'react'
import Button, { IUIButtonProps } from './Button'
import cx from 'classnames'
import css from './button.module.scss'

const SmallButton: FC<React.PropsWithChildren<IUIButtonProps>> = ({ className, ...props }) => {
  return <Button className={cx(css.small_button, className)} {...props} />
}

export default SmallButton
